import React, { useState } from 'react';
import { Button, CustomModal, InputField } from '@repo/ui/components';
import { InputType } from 'sales-common';
export interface ICommentModalProps {
  onSubmit(value: string): void;
  close(): void;
  isOpen: boolean;
  title: string;
}

export const CommentModal = (props: ICommentModalProps) => {
  const [comment, setComment] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  React.useEffect(() => {
    if (!props.isOpen) {
      setComment('');
    }
  }, [props.isOpen]);

  const onSubmit = async () => {
    setIsLoading(true);
    await props.onSubmit(comment);
    setIsLoading(false);
  };

  const handleModalClose = () => {
    props.close();
  };

  if (!props.isOpen) return null;

  return (
    <CustomModal
      open={props.isOpen}
      headerTitle={<span className="text-xl text-black font-extrabold leading-[150%]">{props.title}</span>}
      onCloseClick={handleModalClose}
      overlayColor="var(--color-ultramarine40)"
      className=" max-w-[30rem] w-full h-fit text-xl text-black font-extrabold leading-[150%]"
    >
      <div className="flex p-6 flex-col gap-6 [&_label]:font-semibold border-b rounded-lg">
        <InputField
          id="commentTextAreaID"
          label="Din kommentar"
          type={InputType.TEXT_AREA}
          rows={5}
          disabled={isLoading}
          value={comment}
          onChange={(parsed, _formatted, _event) => {
            setComment(parsed as string);
          }}
          className=" leading-[175%] font-semibold bg-white enabled:hover:bg-white  enabled:focus-visible:outline-0"
        />

        <div className="pt-4 grid grid-cols-2  flex-grow gap-4">
          <Button
            disabled={!comment.trim()}
            onClick={onSubmit}
            variant={'teal'}
            className="disabled:cursor-not-allowed"
          >
            Lagre kommentar
          </Button>
          <Button
            onClick={handleModalClose}
            variant={'teal'}
            appearance={'outline'}
            className="enabled:hover:bg-turquoise"
          >
            Avbryt
          </Button>
        </div>
      </div>
    </CustomModal>
  );
};
